import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=c83cedbe&scoped=true"
import script from "./PartnerDetail.vue?vue&type=script&lang=ts"
export * from "./PartnerDetail.vue?vue&type=script&lang=ts"
import style0 from "./PartnerDetail.vue?vue&type=style&index=0&id=c83cedbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83cedbe",
  null
  
)

export default component.exports